import I18N from '@leverege/i18n'
import { DataViewerModel } from '@leverege/molten/data-viewers'

import EventsView from '../events/EventsView'
import EventsViewModel from '../events/EventsViewModel'

import StationTimelineSupportDataViewer from './StationTimelineSupportDataViewer'

const { tf, tfIcon } = I18N.ns( 'ps.dataViewers.StationTimelineEventsDataViewer' )

export default {
  id : 'ps.dataViewers.StationTimelineEventsDataViewer',
  type : 'ps.StationTimelineEvents',
  name : tf( 'name', 'Station Timeline Events' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : [ 'GroupDataViewer', 'ItemInfoDataViewer' ], objectType : 'station' },
  createSettings : ( props ) => {
    return EventsViewModel.create( {
      dataViewers : [ 
        DataViewerModel.create( 
          StationTimelineSupportDataViewer.type, 
          StationTimelineSupportDataViewer.createSettings( props ) )
      ],
      breakpoints : [ 'minWidth' ]
    } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : '400px' }
}
